export function prefixReturnValue<Args extends Array<unknown>>(prefix: string, cb: (...args: Args) => string): (...args: Args) => string {
    return (...args: Args): string => {
        return `${prefix}${cb(...args)}`;
    };
}